import { Component, EventEmitter, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgIconComponent } from '@ng-icons/core';

@Component({
    selector: 'jft-tender-awards-search-bar',
    templateUrl: './tender-awards-search-bar.component.html',
    styleUrls: ['./tender-awards-search-bar.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, NgIconComponent]
})
export class TenderAwardsSearchBarComponent implements OnInit {
    public term: string = '';

    @Output()
    private onChanges = new EventEmitter<string>();

    constructor() {}

    public ngOnInit() {}

    public search() {
        this.onChanges.emit(this.term);
    }

    public clearTerm() {
        this.term = '';
        this.onChanges.emit(this.term);
    }
}
